import * as React from "react";
import { Modal, Form, Button, Header, Loader } from "semantic-ui-react";
import { Input } from "@neworbit/simpleui-input";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { Action } from "redux";

import { isRequestActive } from "redux-request-loading";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { ApplicationState } from "../../../applicationState";
import { addBloodTestOutcome } from "../../../immunisationOhCase/actions";
import { FollowUpTasks } from "../../../immunisationReview/components/FollowUpTasks";
import { OhCase } from "../../../crud/ohCase";
import { FollowUpTaskModel } from "../../../immunisationReview/model";
import { LOAD_OHCASE_DETAIL } from "../../../crud/ohCase/actiontypes";
import { loadOhCaseDetail } from "../../../crud/ohCase/actions";

interface StateProps {
    ohCases: OhCase[];
    loadingOhCase: boolean;
}

interface DispatchProps {
    submit: (task: TaskModel, outcome: string, details: string, tasks: FollowUpTaskModel[]) => Promise<void>;
    loadOhCase: (ohCaseId: string, customerId: string) => Promise<void>;
}

interface OwnProps {
    onClose: () => void;
    task: TaskModel;
}

interface Props {
    onClose: () => void;
    submit: (outcome: string, details: string, tasks: FollowUpTaskModel[]) => Promise<void>;
    loadOhCase: () => Promise<void>;
    ohCase: OhCase;
    loadingOhCase: boolean;
    task: TaskModel;
}

const outcomes = [
    "<10iu/ml – Not completed full course (Hep B)",
    "<10iu/ml - N/Imm Repeat (HepB)",
    "<10iu/ml - Non Responder (HepB)",
    "<10iu/ml - Old Course (HepB)",
    "<10iu/ml - Primary Course (HepB)",
    "<50 copies/ml (HIV)",
    ">100iu/ml - Imm Boost in 12 Months (HepB)",
    ">100iu/ml - Imm Boost in 5 years (HepB)",
    ">100iu/ml - Immune No Further Action",
    "0-5mm Negative (Mantoux)",
    "10-100iu/ml -Immediate Booster (Hep B)",
    "5mm or greater Positive (Mantoux)",
    "Detectable (HIV Viral Load)",
    "Detected (Hep C RNA)",
    "Equivocal",
    "Immune",
    "Indeterminate",
    "Negative",
    "Not detected (Hep C RNA)",
    "Not Immune",
    "Not Isolated (MRSA Swab)",
    "Positive",
    "Previous Infection Identified",
    "Repeat Blood test insufficient or corrupt sample",
    "Sample Stored",
    "Scar Not Visible",
    "Scar Not Visible - Definite History of Vaccination",
    "Scar Visible",
    "Source Negative",
    "Source Positive",
    "Undetectable (HIV Viral Load)"
];

export const ReviewBloodTestResultModalUnconnected: React.FunctionComponent<Props> = (props) => {
    const [outcome, setOutcome] = React.useState<string>();
    const [details, setDetails] = React.useState<string>();

    const [submitted, setSubmitted] = React.useState(false);
    const [tasks, setTasks] = React.useState([{ task: { taskType: null, immunisationTypeTasks: [] }, isValid: false }]);

    React.useEffect(() => {
        if (!props.ohCase?.immunisations && !props.loadingOhCase) {
            props.loadOhCase();
        }
    }, []);

    const onSubmit = async () => {
        setSubmitted(true);
        if (!outcome || !tasks.every(t => t.isValid)) {
            return;
        }
        await props.submit(outcome, details, tasks.map(t => t.task));
        props.onClose();
    };

    return (
        <Modal open>
            <Modal.Header className="blood-test-results-modal-header">
                Review Blood Test Result
                {props.task.immunisationTypeTasks?.length &&
                    <h5>
                        {props.task.immunisationTypeTasks.map(i => i.name).join(", ")}
                    </h5>
                }
            </Modal.Header>
            <Modal.Content>
                <Form>
                    <Input.Dropdown
                        label="Outcome"
                        options={outcomes.map(o => ({ text: o, value: o }))}
                        value={outcome}
                        onChange={(newOutcome: string) => setOutcome(newOutcome)}
                        required
                        showErrors={submitted}
                        search
                    />
                    <Input.Textarea label="Clinical Notes / Measurements" value={details} onChange={d => setDetails(d)} />
                    <Header content="Next Tasks" as="h5" />
                    {props.ohCase?.immunisations ?
                        <FollowUpTasks
                            immunisationTypes={props.ohCase.immunisations.map(i => i.typeId)}
                            onChange={setTasks}
                            showErrors={submitted}
                            tasks={tasks}
                            assignmentOptionRequired={true}
                        /> :
                        <Loader active inline inverted />
                    }
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button content="Cancel" onClick={props.onClose} />
                <Button content="Submit" onClick={onSubmit} />
            </Modal.Actions>
        </Modal>
    );
};

const mapStateToProps = (state: ApplicationState): StateProps => ({
    ohCases: state.ohCases,
    loadingOhCase: isRequestActive(state, LOAD_OHCASE_DETAIL)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<ApplicationState, void, Action>): DispatchProps => ({
    submit: (task: TaskModel, outcome: string, details: string, tasks: FollowUpTaskModel[]) =>
        dispatch(addBloodTestOutcome(task.customer.id, task.employeeRecord.id, task.caseId, task.id, outcome, details, tasks)),
    loadOhCase: (ohCaseId: string, customerId: string) => dispatch(loadOhCaseDetail({ ohCaseId, customerId }))
});

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps, ownProps: OwnProps): Props => ({
    ...ownProps,
    ...stateProps,
    submit: (outcome: string, details: string, tasks: FollowUpTaskModel[]) => dispatchProps.submit(ownProps.task, outcome, details, tasks),
    loadOhCase: () => dispatchProps.loadOhCase(ownProps.task.caseId, ownProps.task.customer.id),
    ohCase: stateProps.ohCases.find(c => c.id === ownProps.task.caseId)
});

export const ReviewBloodTestResultModal = connect(mapStateToProps, mapDispatchToProps, mergeProps)(ReviewBloodTestResultModalUnconnected);
